import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';
import { useFetchedCampaignGroup } from '../../CampaignGroupField/hooks/useFetchedCampaignGroup';

export const useCampaignTimeFrameRestrictions = () => {
    const {
        data: { campaignGroupInfo },
    } = useFormDataContext();
    const campaignGroup = useFetchedCampaignGroup(campaignGroupInfo?.campaignGroupId);

    return {
        campaignGroupStartDate: campaignGroup?.startDate,
        campaignGroupEndDate: campaignGroup?.endDate,
    };
};
